import React from "react";
//import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import { PropTypes } from "prop-types";
//import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
const FooterMap = props => {
  const mapStyles = {
    width: "200&",
    height: "100%"
  };

  
  const position = [props.latitude, props.longitude]
  return (
    <div>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12091.076874342256!2d14.5278947!3d40.7451034!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xaf4fa2dcef94e7b4!2sDGA%20Planet%20Shirt%20srl!5e0!3m2!1sit!2sit!4v1621440303659!5m2!1sit!2sit" width="100%" height = "500" style={{border:"0"}} allowfullscreen="" loading="lazy"></iframe>

    </div>
    
  );
};

FooterMap.propTypes = {
  google: PropTypes.object,
  latitude: PropTypes.string,
  longitude: PropTypes.string
};

/*export default GoogleApiWrapper({
  apiKey: "AIzaSyBUfHRjiHo-Qyx_jeAVxQLYUmACMtYKRcg"
})(FooterMap);*/
export default FooterMap;